import { TrackingParameters } from "./tracking-parameter";

export class ProspectTourScheduleSelftour {
    constructor (
        public TourDate: Date = null,
        public TourDateString: string = null,
        public TourTime: string = null,
        public YardiKey: string = null,
        public ProspectSource: string = null,
        public Campaign: string = null,
        public AdGroup: string = null,
        public Keyword: string = null,
        public AdCopy: string = null,
        public Device: string = null,
        public Medium: string = null
    ) { }

    LoadFromLocalTourQueryParams()
    {
        let paramsString = localStorage.getItem('TrackingParameters');

        if (paramsString)
        {
            let params: TrackingParameters = JSON.parse(paramsString);
            this.ProspectSource = params.Source;
            this.Campaign = params.Campaign;
            this.AdGroup = params.AdGroup;
            this.Keyword = params.Keyword;
            this.AdCopy = params.AdCopy;
            this.Device = params.Device;
            this.Medium = params.Medium;
        }
    }
}
